(function () {
  const STORAGE_KEY = "fake_low_stock_v5";
  const MIN = 2;
  const MAX = 7;
  const SHOW_RATE = 0.5; // %40 satırda gözüksün

  function loadMap() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}"); }
    catch { return {}; }
  }
  function saveMap(map) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(map)); } catch {}
  }
  function rand(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  function ensureRule(map, variantId) {
    if (!variantId) return null;
    if (!map[variantId]) {
      map[variantId] = { show: Math.random() < SHOW_RATE, stock: rand(MIN, MAX) };
      saveMap(map);
    }
    return map[variantId];
  }

  function getQty(row) {
    // Sende quantity input render ediliyor: {% render 'quantity-input' with id: item.id, initial_value: item.quantity %}
    const input =
      row.querySelector('input[name="updates[]"]') ||
      row.querySelector('input[type="number"]') ||
      row.querySelector('input.quantity__input');

    const q = input ? parseInt(input.value || "1", 10) : 1;
    return Number.isFinite(q) && q > 0 ? q : 1;
  }

  function badge(n) {
    const el = document.createElement("div");
    el.className = "fake-low-stock";
    el.innerHTML = `
      <span class="fake-low-stock__dot" aria-hidden="true"></span>
      <span class="fake-low-stock__text">Tükenmek üzere • Son <b>${n}</b> adet</span>
    `;
    return el;
  }

  function inject() {
    const rows = document.querySelectorAll('.cart__form-item[data-variant-id], [data-cart-row][data-variant-id]');
    if (!rows.length) return;

    const map = loadMap();

    rows.forEach((row) => {
      if (row.querySelector(".fake-low-stock")) return;

      const variantId = row.getAttribute("data-variant-id");
      const rule = ensureRule(map, variantId);
      if (!rule || !rule.show) return;

      const qty = getQty(row);
      const shown = Math.max(MIN, rule.stock - (qty - 1));

      // Senin temada info alanı: .cart__form-item-info ya da .cart__form-item-details
      const target =
        row.querySelector(".cart__form-item-info") ||
        row.querySelector(".cart__form-item-details") ||
        row;

      target.appendChild(badge(shown));
    });
  }

  document.addEventListener("DOMContentLoaded", inject);
  new MutationObserver(inject).observe(document.body, { childList: true, subtree: true });

  // quantity değişince tekrar yazdırmak için:
  document.addEventListener("change", (e) => {
    if (e.target && (e.target.matches('input[name="updates[]"]') || e.target.matches('input[type="number"]'))) {
      // eski badge'i temizleyip yeniden bas
      document.querySelectorAll(".fake-low-stock").forEach((n) => n.remove());
      inject();
    }
  });
})();
